/// <amd-module name="VSSUI/Components/DeprecatedAccordion/Accordion" />
import * as React from "react";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";
import { IAccordionItem, IAccordionProps } from "./Accordion.Props";

/** @deprecated */
export interface IAccordionState {
    expandedDictionary: { [key: string]: boolean };
}

/** @deprecated Please use import { Accordion } from "VSSUI/Accordion" */
export class Accordion extends React.Component<IAccordionProps, IAccordionState> {
    constructor(props: IAccordionProps) {
        super(props);

        const expandedDictionary: { [key: string]: boolean } = {};

        if (this.props.initiallyExpandedGroups) {
            for (const i of props.items) {
                expandedDictionary[i.key] = false;
            }

            for (const i of this.props.initiallyExpandedGroups) {
                expandedDictionary[i] = true;
            }
        } else {
            for (const i of props.items) {
                expandedDictionary[i.key] = props.initiallyExpandAll === true;
            }
        }

        this.state = {
            expandedDictionary: expandedDictionary
        };
    }

    public expand(itemKey: string): void {
        const { expandedDictionary } = this.state;
        if (!expandedDictionary[itemKey]) {
            this.toggleExpand(itemKey);
        }
    }

    public collapse(itemKey: string): void {
        const { expandedDictionary } = this.state;
        if (expandedDictionary[itemKey]) {
            this.toggleExpand(itemKey);
        }
    }

    public render(): JSX.Element {
        return (
            <div className={css("accordion-root", this.props.className)} role={this.props.items.length > 1 ? "tablist" : undefined}>
                {this.renderItems()}
            </div>
        );
    }

    public renderItems(): JSX.Element[] {
        const { items } = this.props;
        const elements: JSX.Element[] = [];
        for (let i = 0; i < items.length; i++) {
            elements.push(this.renderItem(items[i], i));
        }
        return elements;
    }

    public renderItem(item: IAccordionItem, index: number): JSX.Element {
        const { expandedDictionary } = this.state;
        const hasMultipleAccordionItems = this.props.items.length > 1;
        return (
            <div className="accordion-item" key={item.key}>
                <Button
                    subtle={true}
                    onClick={this.toggleExpand.bind(this, item.key)}
                    className="accordion-header"
                    ariaExpanded={expandedDictionary[item.key]}
                    ariaSetSize={hasMultipleAccordionItems ? this.props.items.length : undefined}
                    ariaPosInSet={hasMultipleAccordionItems ? index + 1 : undefined}
                >
                    <Icon iconName={expandedDictionary[item.key] ? "ChevronDown" : "ChevronRight"} className="accordion-chevron" />
                    <Tooltip overflowOnly>
                        <div className="text-ellipsis">{item.title || item.key}</div>
                    </Tooltip>
                </Button>
                <div className={css("accordion-content", !expandedDictionary[item.key] && "hidden")}>{item.onRenderContent()}</div>
            </div>
        );
    }

    public toggleExpand(key: string) {
        const { expandedDictionary } = this.state;
        expandedDictionary[key] = !expandedDictionary[key];
        if (this.props.onItemChanged) {
            this.props.onItemChanged(key, expandedDictionary[key]);
        }
        this.forceUpdate();
    }
}
